import { owcTheme } from 'core/theme/theme.config';
import { TypographyBody2, TypographySubtitle2 } from 'commons/components';
import styled from 'styled-components';

export const TrainingProgramTitle = styled(TypographySubtitle2)`
    color: ${owcTheme['one-color-foreground-intensity-medium'] || '#544f4f'} !important;
`;

export const TrainingProgramTrainerBody = styled(TypographyBody2)`
    color: ${owcTheme['one-color-foreground-intensity-medium'] || '#544f4f'} !important;
`;
